import { Button, Card, CardBody, Flex, Heading, HStack } from "@chakra-ui/react";
import { MISSING_ITEM, MissingAnswerMark } from "./MissingAnswer";
import { useTranslation } from "react-i18next";
import { StatusAccentBar } from "./StatusAccentBar";
import type { StatusVariant } from "./StatusVariant";

interface Props {
  text: string;
  value: boolean | null;
  onChange: (yes: boolean) => void;
  readOnly?: boolean;
  missing?: boolean;
}

export const YesNoQuestionCard = ({ text, value, onChange, readOnly, missing = false }: Props) => {
  const { t } = useTranslation();
  const variant: StatusVariant = value !== null ? "ok" : "neutral";

  return (
    <Card variant="outline" rounded="xl" position="relative" overflow="hidden" {...(missing ? MISSING_ITEM : {})}>
      <StatusAccentBar variant={variant} />
      <CardBody>
        <Flex justify="space-between" align="center" gap="2" mb="4">
          <Heading size="sm">{text}</Heading>
          {missing && <MissingAnswerMark />}
        </Flex>
        <HStack spacing="2">
          <Button
            size="sm"
            variant={value === true ? "solid" : "outline"}
            colorScheme="teal"
            isDisabled={readOnly}
            onClick={() => onChange(true)}
          >
            {t("Yes")}
          </Button>
          <Button
            size="sm"
            variant={value === false ? "solid" : "outline"}
            colorScheme="teal"
            isDisabled={readOnly}
            onClick={() => onChange(false)}
          >
            {t("No")}
          </Button>
        </HStack>
      </CardBody>
    </Card>
  );
};
